import { createContext, useContext, type ReactNode } from "react";

interface AuthState {
  isAuthenticated: boolean;
  isPremium: boolean;
  user: null;
}

const AuthContext = createContext<AuthState>({
  isAuthenticated: true,
  isPremium: false,
  user: null,
});

export function AuthProvider({ children }: { children: ReactNode }) {
  // Placeholder: always "authenticated" for now
  const value: AuthState = {
    isAuthenticated: true,
    isPremium: false,
    user: null,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
